import React from 'react';
import { ScrollView, StyleSheet, Text, View, ViewStyle } from 'react-native';
import { C, FONT, SP } from '../../theme/tokens';

type CalcScreenProps = {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  backgroundColor?: string;
  contentContainerStyle?: ViewStyle;
};

/**
 * Shell for overview / category / list screens (NOT individual calculators —
 * those use `CalcShell`). Provides the same eyebrow + title chrome as
 * CalcShell so the app feels cohesive top-to-bottom.
 */
export function CalcScreen({
  title,
  subtitle,
  children,
  backgroundColor = C.bg,
  contentContainerStyle,
}: CalcScreenProps) {
  return (
    <ScrollView
      style={[styles.container, { backgroundColor }]}
      contentContainerStyle={[styles.contentContainer, contentContainerStyle]}
    >
      <View style={styles.inner}>
        <CalcHeader title={title} subtitle={subtitle} />
        {children}
      </View>
    </ScrollView>
  );
}

export function CalcHeader({ title, subtitle }: { title: string; subtitle?: string }) {
  return (
    <View style={styles.header}>
      {subtitle ? (
        <View style={styles.eyebrowRow}>
          <View style={styles.eyebrowBar} />
          <Text style={styles.eyebrowText}>{subtitle.toUpperCase()}</Text>
        </View>
      ) : null}
      <Text style={styles.title}>{title}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1 },
  contentContainer: { padding: SP.md, paddingBottom: SP.xl },
  inner: { width: '100%', maxWidth: 980, alignSelf: 'center' },
  header: { marginBottom: SP.md },
  eyebrowRow: { flexDirection: 'row', alignItems: 'center', marginBottom: SP.xs },
  eyebrowBar: {
    width: 4, height: 11,
    backgroundColor: C.accent, borderRadius: 1,
    marginRight: SP.sm,
  },
  eyebrowText: {
    fontFamily: FONT.mono,
    fontSize: 11,
    color: C.dim,
    letterSpacing: 0.8,
  },
  title: {
    fontFamily: FONT.sansBold,
    fontSize: 26,
    color: C.ink,
    letterSpacing: -0.3,
  },
});
